/*
 * Exhibitions.
 *
 * Las fichas se pliegan solas: son <details> nativos. Esto anade tres cosas
 * que el navegador no hace:
 *
 *  1. Solo una abierta a la vez.
 *  2. Entrar por ancla (/pages/exhibitions#whispers-beijing) abre esa ficha
 *     y la trae a la vista, con el desplazamiento corregido por la cabecera
 *     fija via scroll-margin-top.
 *  3. Las tarjetas del carrusel abren su ficha en vez de saltar en seco.
 *
 * Las fichas son secciones hermanas, sin envoltorio comun, asi que esto no
 * es un custom element: busca en el documento y se ejecuta una sola vez
 * aunque las cuatro secciones pidan el mismo archivo.
 */

(function () {
  const fichas = () => Array.from(document.querySelectorAll('[data-reda-expo]'));

  function cerrarLasDemas(abierta) {
    fichas().forEach((f) => {
      if (f !== abierta) f.open = false;
    });
  }

  function abrir(ficha, desplazar) {
    if (!ficha) return;

    ficha.open = true;
    cerrarLasDemas(ficha);

    if (!desplazar) return;

    ficha.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start',
    });
  }

  function porHash(desplazar) {
    const id = decodeURIComponent((window.location.hash || '').slice(1));
    if (!id) return;

    // getElementById y no querySelector: un ancla puede llevar caracteres
    // que romperian el selector.
    const destino = document.getElementById(id);
    if (destino && destino.hasAttribute('data-reda-expo')) abrir(destino, desplazar);
  }

  fichas().forEach((ficha) => {
    ficha.addEventListener('toggle', () => {
      if (ficha.open) cerrarLasDemas(ficha);
    });
  });

  document.querySelectorAll('[data-reda-tarjeta]').forEach((tarjeta) => {
    tarjeta.addEventListener('click', (evento) => {
      const id = decodeURIComponent((tarjeta.getAttribute('href') || '').slice(1));
      const destino = document.getElementById(id);
      if (!destino) return;

      // Se deja que el navegador cambie el hash, para que el enlace se pueda
      // copiar y compartir, pero el salto lo damos nosotros ya abierta.
      evento.preventDefault();
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', '#' + id);
      }
      abrir(destino, true);
    });
  });

  window.addEventListener('hashchange', () => porHash(true));

  // Al cargar: abrir sin animacion, que la pagina aun se esta asentando.
  porHash(false);
})();
